import React from 'react';
export const Header = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <header className="w-full py-6 px-6 md:px-10 fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-200" data-id="element-161">
      <div className="max-w-[1600px] mx-auto flex justify-between items-center" data-id="element-162">
        <div className="flex items-center gap-2" data-id="element-163">
          <div className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-164">МБ</div>
          <div className="h-8 w-px bg-[#2c5f2d] mx-3" data-id="element-165"></div>
          <div className="hidden sm:block text-gray-600 text-sm uppercase tracking-widest" data-id="element-166">
            Психолог
          </div>
        </div>
        <nav className="flex items-center gap-6 md:gap-8" data-id="element-167">
          <button onClick={() => scrollToSection('about')} className="text-gray-600 hover:text-[#2c5f2d] transition-colors text-sm uppercase tracking-wider hidden lg:block" data-id="element-168">
            Обо мне
          </button>
          <button onClick={() => scrollToSection('testimonials')} className="text-gray-600 hover:text-[#2c5f2d] transition-colors text-sm uppercase tracking-wider hidden md:block" data-id="element-169">
            Отзывы
          </button>
          <button onClick={() => scrollToSection('education')} className="text-gray-600 hover:text-[#2c5f2d] transition-colors text-sm uppercase tracking-wider hidden lg:block" data-id="element-170">
            Образование
          </button>
          <button onClick={() => scrollToSection('services')} className="text-gray-600 hover:text-[#2c5f2d] transition-colors text-sm uppercase tracking-wider" data-id="element-171">
            Услуги
          </button>
          <button onClick={() => scrollToSection('contact')} className="px-6 py-2 bg-[#2c5f2d] text-white text-sm font-semibold uppercase tracking-wider hover:bg-[#1f4520] transition-colors rounded-lg" data-id="element-172">
            Записаться
          </button>
        </nav>
      </div>
    </header>;
};